import { TFunction } from 'i18next';
import ProcessingActivity, {
  PrivacyFramework,
  ProcessingActivityRole,
  ProcessingActivityState,
} from 'models/processingActivity';
import { DataZoneKey } from 'models/stringValue/stringValue';
import ProcessingActivityDTO from '../processingActivity/processingActivityDTO';
import ReportRequestDTO from './ReportRequestDTO';

export class ReportRequest19DTO extends ReportRequestDTO {
  processingActivityColumns: string[];

  processingActivityRoles: Record<ProcessingActivityRole, string>;

  processingActivityStates: Record<ProcessingActivityState, string>;

  transferOptions: Record<DataZoneKey, string>;

  chartSeriesLabel: string;

  processingActivities: ProcessingActivityDTO[];

  constructor(report: ReportRequestDTO, t?: TFunction<string[]>, privacyFramework?: PrivacyFramework) {
    super(report);
    this.processingActivities = [];
    this.processingActivityColumns = [];
    this.transferOptions = {} as Record<DataZoneKey, string>;
    this.processingActivityRoles = {} as Record<ProcessingActivityRole, string>;
    this.processingActivityStates = {} as Record<ProcessingActivityState, string>;
    this.chartSeriesLabel = '';

    if (t && privacyFramework !== undefined) {
      this.processingActivityColumns = [
        t('processingActivities:TabOverview.Column.Code'),
        t('processingActivities:TabOverview.Column.Name'),
        t('processingActivities:TabOverview.Column.Role'),
        t('processingActivities:TabOverview.Column.State'),
        t('processingActivities:TabOverview.Column.Owner'),
        t('processingActivities:TabOverview.Column.Data'),
        t('processingActivities:TabOverview.Column.Classifications'),
        t('processingActivities:TabOverview.Column.DataSubjectScale'),
        t('processingActivities:TabOverview.Column.Transfers.Label'),
        t('processingActivity:TabDetails.Fields.Purpose.Label'),
        t('processingActivity:TabDetails.StringValueLabels.LegalBasis'),
        t('processingActivity:TabDetails.Fields.RetentionPeriod'),
        t('processingActivity:TabDetails.AssetList.Label.Processors'),
        t('processingActivity:TabDetails.AssetList.Label.Recipients'),
      ];
      this.processingActivityRoles = {
        [ProcessingActivityRole.Controller]: t('processingActivity:Role.Controller'),
        [ProcessingActivityRole.Processor]: t('processingActivity:Role.Processor'),
      };
      this.processingActivityStates = {
        [ProcessingActivityState.Concept]: t('processingActivity:State.Concept'),
        [ProcessingActivityState.Approved]: t('processingActivity:State.Approved'),
        [ProcessingActivityState.Archived]: t('processingActivity:State.Archived'),
        [ProcessingActivityState.AwaitingApproval]: t('processingActivity:State.AwaitingApproval'),
        [ProcessingActivityState.Review]: t('processingActivity:State.Review'),
      };

      this.transferOptions = {
        [DataZoneKey.None]: '',
        [DataZoneKey.TenantZone]: ProcessingActivity.getTransfersText(DataZoneKey.TenantZone, t, privacyFramework),
        [DataZoneKey.Adequate]: ProcessingActivity.getTransfersText(DataZoneKey.Adequate, t, privacyFramework),
        [DataZoneKey.Other]: ProcessingActivity.getTransfersText(DataZoneKey.Other, t, privacyFramework),
      };

      this.chartSeriesLabel = t('processingActivities:TabOverview.Column.State');
    }
  }

  clone(): ReportRequest19DTO {
    const output = new ReportRequest19DTO(this);
    output.processingActivities = [...this.processingActivities];
    output.processingActivityColumns = [...this.processingActivityColumns];
    output.processingActivityRoles = { ...this.processingActivityRoles };
    output.processingActivityStates = { ...this.processingActivityStates };
    output.transferOptions = { ...this.transferOptions };
    output.chartSeriesLabel = this.chartSeriesLabel;

    return output;
  }
}
